"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.Biolab = void 0;
var Tags_1 = require("../Tags");
var PreludeCard_1 = require("./PreludeCard");
var Resources_1 = require("../../Resources");
var CardName_1 = require("../../CardName");
var CardRenderer_1 = require("../render/CardRenderer");
var Biolab = (function (_super) {
    __extends(Biolab, _super);
    function Biolab() {
        return _super.call(this, {
            name: CardName_1.CardName.BIOLAB,
            tags: [Tags_1.Tags.SCIENCE],
            metadata: {
                cardNumber: 'P04',
                renderData: CardRenderer_1.CardRenderer.builder(function (b) {
                    b.production(function (pb) { return pb.plants(1); }).br;
                    b.cards(3);
                }),
                description: 'Increase your plant production 1 step. Draw 3 cards.',
            },
        }) || this;
    }
    Biolab.prototype.play = function (player) {
        player.addProduction(Resources_1.Resources.PLANTS, 1);
        player.drawCard(3);
        return undefined;
    };
    return Biolab;
}(PreludeCard_1.PreludeCard));
exports.Biolab = Biolab;
